'use strict';

var pseudoStyle = require('./pseudo-style');
module.exports = pseudoStyle('disabled', 'disabledStyle')({
  color: 'colors',
  backgroundColor: 'colors',
  borderColor: 'colors',
  boxShadow: 'shadows'
});


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/disabled.js
// module id = 1050
// module chunks = 168707334958949